import React, { lazy, memo } from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
const bonuses = [{
  num: 1,
  title: 'Certificados, registros, formularios y actas listos para documentar cada capacitación.',
  desc: 'Certificados, registros, formularios y actas listos para documentar cada capacitación.',
  image: 'https://cdn.magicpatterns.com/uploads/rNptbHThqvvb4WA1vGX5sz/Bonus_1_-_El_Registro_Maestro_de_Evidencia_Legal.webp'
}, {
  num: 2,
  title: 'Todo el sistema de evaluación listo para medir y documentar cada capacitación.',
  desc: 'Cuestionarios de evaluación para los 52 temas del programa anual. Multiple Choice y Verdadero/Falso con grilla de respuestas para corrección instantánea. Planillas de seguimiento de rendimiento por trabajador. Demostrá el impacto real de cada capacitación que das.',
  image: 'https://cdn.magicpatterns.com/uploads/aCaARkzmGLLxmEwVQ95Kpt/Bonus_2_-_Banco_de_Evaluacion_y_Control_de_Aprendizaje.webp'
}, {
  num: 3,
  title: 'Guía de Dinámicas y Talleres In-Situ',
  desc: '25 dinámicas grupales y ejercicios prácticos listos para usar. Rompehielos técnicos para temas críticos como altura y espacios confinados. Actividades de percepción de riesgos para operarios. Capacitaciones que los trabajadores recuerdan.',
  image: 'https://cdn.magicpatterns.com/uploads/2qveD2ybEWBtDf2gtQCiSZ/Bonus_3_-_Guia_de_Dinamicas_y_Talleres_In-Situ.webp'
}, {
  num: 4,
  title: 'Cronogramas de Gestión y Tableros de Control',
  desc: 'Plantillas de planificación mes a mes para las 52 semanas. Matrices de seguimiento por puesto de trabajo. Tableros de KPIs de gestión preventiva. Cuadros de avance para presentar a gerencia. El cerebro organizacional de tu consultoría anual.',
  image: 'https://cdn.magicpatterns.com/uploads/7338oFX8EKJ9zrXsNG9pyZ/Bonus_4_-_Cronogramas_de_Gestion_y_Tableros_de_Control.webp'
}, {
  num: 5,
  title: 'Kit de Material Didáctico Visual y Señalética',
  desc: 'Infografías técnicas listas para imprimir por tema. Folletos resumen de bolsillo para entregar a los trabajadores. Señalética y carteles para áreas críticas. Ayuda-memorias para puestos de trabajo específicos. El toque profesional que hace que el cliente te vea diferente desde el primer día.',
  image: 'https://cdn.magicpatterns.com/uploads/hNEyh7aPJPXhgtMjQUS8iX/Bonus_5_-_Kit_de_Material_Didactico_Visual_y_Senaletica.webp'
}];
export function BonusesSection() {
  return <section className="py-16 md:py-24 bg-transparent" data-id="element-12">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-13">
        <div className="text-center mb-10" data-id="element-14">
          <span className="inline-flex items-center gap-2 px-6 py-2.5 mb-5 rounded-full border border-white/40 bg-[#4A553F] text-white font-semibold tracking-[0.18em] uppercase text-xs" data-id="element-15">
            <Gift className="w-4 h-4 text-[#d4a017]" data-id="element-16" />5 Bonos Incluidos
          </span>
          <h2 className="font-heading font-bold text-[#2f3a2c] text-3xl md:text-5xl leading-tight" data-id="element-17">
            Y además, recibís{' '}
            <span className="italic text-[#5C6851]" data-id="element-18">5 bonos de lujo</span>
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 gap-5 mb-10" data-id="element-19">
          {bonuses.map((b, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="bg-white border border-slate-200 rounded-2xl p-3 shadow-sm" data-id="element-20">
              <div className="relative rounded-xl overflow-hidden mb-3 h-56 bg-[#f4efe2] flex items-center justify-center" data-id="element-21">
                <img src={b.image} alt={`Bono ${b.num}: ${b.title}`} width={400} height={500} loading="lazy" decoding="async" className="w-full h-full object-contain" data-id="element-22" />
                <span className="absolute top-2.5 left-2.5 bg-rose-500 text-white font-bold text-[11px] tracking-wide uppercase px-2.5 py-1 rounded-md shadow-sm" data-id="element-23">
                  Bono {b.num}
                </span>
                <span className="absolute top-2.5 right-2.5 inline-flex items-center gap-1 bg-emerald-600 text-white font-bold text-[11px] tracking-wide uppercase px-2.5 py-1 rounded-md shadow-sm" data-id="element-24">
                  🎁 Gratis
                </span>
              </div>
              <div className="px-2 pb-2" data-id="element-25">
                <h3 className="font-heading font-bold text-[#2f3a2c] mb-1.5 text-[15px]" data-id="element-26">
                  {b.title}
                </h3>
                <p className="text-slate-500 text-sm leading-snug" data-id="element-27">{b.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center px-6 py-10 bg-white/60 border border-amber-100 rounded-3xl" data-id="element-28">
          <Gift className="w-9 h-9 text-[#d4a017] mx-auto mb-4" data-id="element-29" />
          <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#5C6851] mb-2" data-id="element-30">
            Todo incluido en
          </p>
          <h3 className="font-heading font-bold text-[#2f3a2c] text-3xl md:text-4xl mb-3" data-id="element-31">
            el Sistema Maestro
          </h3>
          <p className="text-slate-600" data-id="element-32">
            Los 5 bonos son gratis con tu compra hoy.
          </p>
        </div>
      </div>
    </section>;
}